import React, { useState, useEffect } from 'react';
import styles from '../styles/MovementModal.module.css';
import { API_URL } from '../config/api';

const MovementModal = ({ onClose, onSubmit }) => {
  const [storages, setStorages] = useState([]);
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [comment, setComment] = useState('');
  const token = localStorage.getItem('token'); // ✅ Берём токен

  useEffect(() => {
    const fetchStorages = async () => {
      if (!token) {
        console.error('❌ Нет токена! Авторизация не выполнена.');
        return;
      }

      try {
        const response = await fetch(`${API_URL}/api/storages`, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`, // ✅ Токен для запроса
          },
        });

        if (!response.ok) {
          console.warn(`⚠️ Ошибка при загрузке складов: ${response.status}`);
          // 🔹 Подгружаем из localStorage, если есть
          const saved = localStorage.getItem('storages');
          if (saved) setStorages(JSON.parse(saved));
          return;
        }

        const data = await response.json();
        setStorages(data.data || []);

        // 🔹 Сохраняем в localStorage на случай следующей ошибки
        localStorage.setItem('storages', JSON.stringify(data.data || []));
      } catch (error) {
        console.error('Ошибка при загрузке складов:', error);
        const saved = localStorage.getItem('storages');
        if (saved) setStorages(JSON.parse(saved));
      }
    };

    fetchStorages();
  }, [token]);

  const handleSubmit = () => {
    if (from && to && from !== to) {
      onSubmit({ from, to, comment });
    } else {
      alert('Пожалуйста, выберите два разных склада.');
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2 className={styles.title}>Перемещение</h2>
          <button onClick={onClose} className={styles.closeButton}>×</button>
        </div>

        <div className={styles.content}>
          {/* Левая колонка (Со склада) */}
          <div className={`${styles.column} ${styles.scrollable}`}>
            <h4 className={styles.titleHeading}>Со склада</h4>
            {storages.map((item) => (
              <label key={item.id} className={styles.radioLabel}>
                <input
                  type="radio"
                  value={item.id}
                  checked={from === item.id}
                  onChange={() => setFrom(item.id)}
                />
                <span className={styles.truncate}>{item.name}</span>
              </label>
            ))}
          </div>

          <div className={styles.arrow}></div>

          {/* Правая колонка (На склад) */}
          <div className={`${styles.column} ${styles.scrollable}`}>
            <h4 className={styles.titleHeading}>На склад</h4>
            {storages.map((item) => (
              <label key={item.id} className={styles.radioLabel}>
                <input
                  type="radio"
                  value={item.id}
                  checked={to === item.id}
                  onChange={() => setTo(item.id)}
                />
                <span className={styles.truncate}>{item.name}</span>
              </label>
            ))}
          </div>
        </div>

        <textarea
          placeholder="Комментарий"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          className={styles.textarea}
        />

        <div className={styles.footer}>
          <button onClick={onClose} className={styles.cancel}>Отмена</button>
          <button onClick={handleSubmit} className={styles.submit}>Переместить</button>
        </div>
      </div>
    </div>
  );
};

export default MovementModal;
